import { useCallback } from 'react';

import { useIsSupportPanelOpen } from 'state/isSupportPanelOpen';
import { useHasAgentConversationStarted } from 'state/hasAgentConversationStarted';
import { useSubscribe } from 'hooks/useSubscribe';
import { MessagingServiceEvent } from 'genesys/messaging-service-plugin';

import { useSetGenesysError, DefinedError } from './error-state';

/**
 * GBB-MSG-0004
 */
export const useConnectInConversationError = () => {
  const isSupportPanelOpen = useIsSupportPanelOpen();
  const isInConversation = useHasAgentConversationStarted();
  const enabledSubscription = isSupportPanelOpen && isInConversation;

  const setGenesysError = useSetGenesysError();

  const handleError = useCallback(() => {
    setGenesysError(DefinedError.InConversationError);
  }, [setGenesysError]);

  useSubscribe(MessagingServiceEvent.Error, handleError, enabledSubscription);
};

/**
 * GBB-MSG-0001
 */
export const useConnectAuthConversationRestoreError = () => {
  const setGenesysError = useSetGenesysError();

  const handleError = useCallback(() => {
    setGenesysError(DefinedError.AuthConversationRestoreError);
  }, [setGenesysError]);

  const removeError = useCallback(() => {
    setGenesysError('');
  }, [setGenesysError]);

  useSubscribe(MessagingServiceEvent.RestoreFailed, handleError);

  useSubscribe(MessagingServiceEvent.Started, removeError);
};
